





import Vue from 'vue'
import activeInfoPage from '@/components/Ui/ActiveInfoPage/ActiveInfoPage.vue'
import config from '@/activePages/polls/rcpts'
// import Student from '@/models/Students/Student'
import Poll from '@/models/polls/Poll'

export default Vue.extend({
  name: 'PollPageInfo',
  props: {
    id: String
  },
  data () {
    return {
      config
    }
  },
  components: {
    activeInfoPage
  },
  computed: {
    poll (): Poll {
      return this.$store.state.poll.polls[this.id]
    }
  }
})
